export default __webpack_public_path__ + "static/myself-f5ca25afb24463c9b916b0447073e28b.png";